import { useMotionValueEvent, useScroll } from 'framer-motion';
import DownloadSVG from 'public/icons/download.svg';
import PdfSVG from 'public/icons/pdf.svg';
import React, { useRef, useState } from 'react';
import { Day } from '@/entities/day';
import { Direction } from '@/entities/direction';
import { Document } from '@/entities/document';
import { Format } from '@/entities/format';
import { Place } from '@/entities/place';
import { ApiProgramRequest, AppProgramResponse } from '@/shared/api/program';
import { isPdf } from '@/shared/hooks/use-form-sender/validator/utils';
import DownloadPdfBtn from '../../shared/DownloadPdfBtn/DownloadPdfBtn';
import Link from '../../shared/Link';
import ProgramDetailSection, { ProgramDetailSectionProps } from '../ProgramDetailSection/ProgramDetailSection';

type Props = React.HTMLAttributes<HTMLElement> & {
    reflectFilterStateInUrl?: boolean;
    programDetailSectionProps: ProgramDetailSectionProps;
    initialParams: ApiProgramRequest;
    initialResponse: AppProgramResponse;
    days: Day[];
    formats: Format[];
    places: Place[];
    directions: Direction[];
    title: string;
    titleTag?: keyof JSX.IntrinsicElements;
    file?: Document | null;
    downloadPDF?: boolean;
};

function ProgramDetailSeparateSection({
    days,
    formats,
    initialParams,
    places,
    directions,
    initialResponse,
    programDetailSectionProps,
    title,
    titleTag = 'h1',
    file,
    downloadPDF,
}: Props) {
    const TitleComponent = titleTag;

    const ref = useRef(null);
    const [isButtonVisible, setIsButtonVisible] = useState(false);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ['start end', 'end start'],
    });
    useMotionValueEvent(scrollYProgress, 'change', (progress) => {
        setIsButtonVisible(progress > 0 && progress < 1);
    });
    return (
        <section className="program-detail-separate-section wrapper" id="program-list" ref={ref}>
            <div className="program-detail-title-block">
                <div className="program-detail-title-block-text">
                    <TitleComponent className="program-detail-title h2">{title}</TitleComponent>
                </div>
                {file && file.src && (
                    <div className="program-detail-title-btns">
                        <div className="program-detail-presentation-btn">
                            <Link
                                className="presentation-btn-left"
                                target={isPdf(file.src) ? '_blank' : undefined}
                                rel={isPdf(file.src) ? 'noreferrer' : undefined}
                                download={isPdf(file.src) ? undefined : true}
                                href={file.src}
                            >
                                <PdfSVG className="pdf-svg" />
                                <div className="text-xs">{file.title}</div>
                            </Link>

                            <DownloadSVG className="download-svg" />
                        </div>
                    </div>
                )}
                {downloadPDF && <DownloadPdfBtn />}
            </div>
            <ProgramDetailSection
                programDetailSectionProps={programDetailSectionProps}
                isButtonVisible={isButtonVisible}
                days={days}
                directions={directions}
                places={places}
                formats={formats}
                initialParams={initialParams}
                initialResponse={initialResponse}
                isHrSummit
                visibleCardsCount={6}
                pdfTitle="Главная тема Форума TNF 2026 <br/> Нефтегазовая отрасль будущего: энергия лидерства"
            />
        </section>
    );
}

export default ProgramDetailSeparateSection;
